import React from 'react';
import { Box, CircularProgress, Typography, Tooltip, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { computeQualityScore, getScoreColor } from '../utils/qualityScoring';

const QualityScore = ({ doc, size = 'small', showSuggestions = false }) => {
  const { score, suggestions } = computeQualityScore(doc);
  const color = getScoreColor(score);

  const circleSize = size === 'small' ? 36 : 56;
  const fontSize = size === 'small' ? '0.65rem' : '1rem';

  return (
    <Tooltip title={`Document quality: ${score}/100`} arrow>
      <Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={score}
              size={circleSize}
              thickness={4}
              sx={{ color }}
            />
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <Typography sx={{ fontSize, fontWeight: 700, color, lineHeight: 1 }}>{score}</Typography>
            </Box>
          </Box>
          {size !== 'small' && <Typography variant="caption" color="text.secondary">Quality</Typography>}
        </Box>

        {showSuggestions && suggestions.length > 0 && (
          <List dense disablePadding sx={{ mt: 1 }}>
            {suggestions.map((s, idx) => (
              <ListItem key={idx} disablePadding sx={{ py: 0.25 }}>
                <ListItemIcon sx={{ minWidth: 24 }}><TipsAndUpdatesIcon sx={{ fontSize: 14, color: 'warning.main' }} /></ListItemIcon>
                <ListItemText primary={<Typography variant="caption" color="text.secondary">{s}</Typography>} />
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </Tooltip>
  );
};

export default QualityScore;
